import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, TransportTypeActiveRequestDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class ActiveTransportCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  ISaveTransportCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierId}/transportTypes/{transportTypesId}';
  public override setParameters(parameters: ISaveTransportCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{transportTypesId}',
      parameters.transportTypesId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface ISaveTransportCommandParameters
  extends TransportTypeActiveRequestDTO,
    ICommandParameters {
  transportTypesId: string;
  carrierId: string;
  userId: number;
}
